import React from 'react';
import PropTypes from 'prop-types';

import IconPercentage from '../../atoms/IconPercentage';
import IconClose from '../../atoms/IconClose';

import { StyledFloatingButton } from './skins';

export default function FloatingButton({
  onExpandPopup,
  onCloseFloating,
  showOfferIcon,
  ...restProps
}) {
  return (
    <StyledFloatingButton
      onClick={onExpandPopup}
      className="mr-popup-floating-button"
      buttonStyle="filled"
      borderColor="transparent"
      rightPosition={restProps.floatingRightPosition}
      bottomPosition={restProps.floatingBottomPosition}
      backgroundColor={restProps.floatingBackgroundColor}
      borderRadius={restProps.floatingBorderRadius}
      textColor={restProps.floatingTextColor}
      fontSize={restProps.floatingFontSize}
      mobileFontSize={restProps.floatingMobileFontSize}
      fontStyle={restProps.floatingFontStyle}
      fontWeight={restProps.floatingFontWeight}
      textDecoration={restProps.floatingTextDecoration}
      textAlignment={restProps.floatingTextAlignment}
      fontFamily={restProps.floatingFontFamily}
      padding={restProps.floatingPadding}
      margin={restProps.floatingMargin}
      height={restProps.floatingHeight}
      width={
        !restProps.floatingWidth || restProps.floatingWidth === '0'
          ? 'auto'
          : restProps.floatingWidth
      }
    >
      {showOfferIcon && (
        <IconPercentage
          color={restProps.floatingTextColor}
          fontSize="30"
          mobileFontSize="30"
          className="mr-popup-floating-button__offer-icon"
        />
      )}
      {restProps.floatingText}
      <IconClose
        color={restProps.floatingTextColor}
        fontSize={restProps.floatingFontSize}
        mobileFontSize={restProps.floatingMobileFontSize}
        className="mr-popup-floating-button__close-icon"
        onClick={e => {
          e.stopPropagation();
          onCloseFloating();
        }}
      />
    </StyledFloatingButton>
  );
}

FloatingButton.propTypes = {
  onExpandPopup: PropTypes.func,
  onCloseFloating: PropTypes.func,
  showOfferIcon: PropTypes.bool,
};
